import React from "react";
import { BaseComponent } from "..";
import DataList from "../DataList";
import CustomTableExpand from "../CustomTableExpand";
import CustomSelect from "../Macros/CustomSelect";

const columns = [
  {
    title: "שם קופת גמל",
    dataIndex: "fundName",
    key: "fundName",
    width: 220,
    minWidth: 120,
  },
  {
    title: "מספר אישור קופת גמל",
    dataIndex: "govID",
    key: "govID",
    width: 150,
    minWidth: 90,
  },
  {
    title: "שם המעסיק",
    dataIndex: "employerName",
    key: "employerName",
    width: 180,
    minWidth: 120,
  },
  {
    title: "מספר מזהה",
    dataIndex: "employerID",
    key: "employerID",
    width: 140,
    minWidth: 90,
  },
  {
    title: "שנת מס",
    dataIndex: "yearTax",
    key: "yearTax",
    width: 80,
    minWidth: 60,
    align: "center",
  },
  {
    title: "",
    dataIndex: "action",
    minWidth: 140,
  },
];

const intNum = (num, fixed = 0) => {
  if (num) {
    if (fixed) {
      return `${`${num.toFixed(fixed)}`
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ₪`;
    }
    return `${`${Math.round(num)}`
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ₪`;
  }
  return null;
};

export default class PaymentClassification extends BaseComponent {
  constructor(props) {
    super(props);
    let years = this.siteSetting("tax_years_list").split(",");
    years.unshift("שנה");
    this.state = {
      details: null,
      isLoading: true,
      pageNo: this.props.pageNo || 1,
      selectedYear: "",
      isResetForm: false,
      years: years.map(
        (x, i) =>
        ({
          label: x.toString(),
          value: i === 0 ? "" : x.toString(),
        })
      ),
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.accountId !== this.props.accountId ||
      prevState.pageNo !== this.state.pageNo  && !this.state.isResetForm
    ) {
      this.props.onPagination(this.state.pageNo, this.state.selectedYear);
    }
  }

  resetForm(event) {
    this.setState({ selectedYear: "", pageNo: 1, isResetForm: true }, () => {
      this.props.onPagination();
      this.setState({ isResetForm: false });
    });
    event.preventDefault();
  }

  submitForm(event) {
    this.setState({ pageNo: 1 }, this.props.onPagination(this.state.pageNo, parseInt(this.state.selectedYear)));
    event.preventDefault();
  }

  getOptions() {
    var syb = this.siteSetting('lastyeartoshowtaxreports')
    var maxRevaluationDate = parseInt(sessionStorage.getItem("maxRevaluationDate"));
    var years = new Array();
    years.unshift("שנה");
    const bottom = parseInt(syb);
    for (let year = maxRevaluationDate; year >= bottom; year--) {
      years.push(year);
    }

    return years.map(
      (x, i) =>
      ({
        label: x.toString(),
        value: i === 0 ? "" : x.toString(),
      })
    )

  }

  getDataList(record) {
    const dataList = [
      {
        title: "סך הפקדה מצטברת לשנת המס לפי מרכיב חשבון",
        items: [
          {
            label: "תגמולים עובד",
            value: intNum(record?.employeeRewards),
          },
          {
            label: "תגמולים מעסיק",
            value: intNum(record.employerRewards),
          },
          { label: "פיצויים", value: intNum(record.compensations) },
          {
            label: "השתלמות עובד",
            value: intNum(record.employeeStudyFund),
          },
          {
            label: "השתלמות מעסיק",
            value: intNum(record.employerStudyFund),
          },
        ],
      },
      {
        title: "סך הפקדה מצטברת שלא חויבו במס בשלב ההפקדה לפי מרכיב חשבון",
        items: [
          {
            label: "תגמולים עובד",
            value: intNum(record.employeeRewardsQualifyingAllowanceExempt),
          },
          {
            label: "תגמולים מעסיק",
            value: intNum(record.employerRewardsQualifyingAllowanceExempt),
          },
          {
            label: "פיצויים",
            value: intNum(record.compensationsQualifyingAllowanceExempt),
          },
          {
            label: "השתלמות עובד",
            value: intNum(record.employeeStudyFundDebt),
          },
          {
            label: "השתלמות מעסיק",
            value: intNum(record.employerStudyFundDebt),
          },
        ],
      },
      {
        title: "סך הפקדה מצטברת שחויבה במס בשלב ההפקדה לפי מרכיב חשבון",
        items: [
          {
            label: "תגמולים עובד",
            value: intNum(record.employeeRewardsQualifyingAllowance),
          },
          {
            label: "תגמולים מעסיק",
            value: intNum(record.employerRewardsQualifyingAllowance),
          },
          {
            label: "פיצויים",
            value: intNum(record.compensationsQualifyingAllowance),
          },
          {
            label: "השתלמות עובד",
            value: intNum(record.employeeStudyFundPossibilityDebt),
          },
          {
            label: "השתלמות מעסיק",
            value: intNum(record.employerStudyFundPossibilityDebt),
          },
        ],
      },
    ];
    return dataList;
  }

  render() {
    return (
      <div className="pane-content pane-content--payment-classification">
        <div className="filter-block-wrapper">
          <div className="filter-block">
            <h3 className="filter-block__heading">סנן לפי</h3>

            <button
              type="button"
              data-toggle="collapse"
              data-target="#collapseFilter"
              aria-expanded="false"
              aria-controls="collapseFilter"
              aria-label="toggle controls"
              className="filter-block__toggle collapsed"
            >
              <span className="caption">סנן לפי</span>
            </button>

            <div
              id="collapseFilter"
              className="collapse filter-block__collapse show"
            >
              <form
                id="tax-reports-filter-form"
                className="data-filter filter-block__form"
              >
                <div className="data-filter__row">
                  <div className="data-filter__inputs">
                    <div className="data-filter__inputs-row">
                      <div className="col-auto data-filter__col">
                        <label htmlFor="df-date" className="sr-only">
                          שנה
                        </label>
                        <CustomSelect
                          id="df-date"
                          buttonClassName="data-filter__input"
                          options={this.getOptions()}
                          value={this.state.selectedYear}
                          onChange={(value) => {
                            this.setState({ selectedYear: value });
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="data-filter__buttons">
                    <div className="data-filter__buttons-row">
                      <div className="col-auto data-filter__buttons-col">
                        <button
                          type="button"
                          className="data-filter__btn data-filter__btn--reset"
                          onClick={this.resetForm.bind(this)}
                        >
                          נקה
                        </button>
                      </div>
                      <div className="col-auto data-filter__buttons-col">
                        <button
                          type="button"
                          className="data-filter__btn"
                          onClick={this.submitForm.bind(this)}
                        >
                          הצג
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {this.state.isLoadingPaymentClassification ? (
          <div style={{ textAlign: "center" }}>
            <img
              src="/img/loading.gif"
              alt="loading"
              style={{ height: "50px" }}
            />
          </div>
        ) : (
          this.props.data && (
            <>
              <CustomTableExpand
                columns={columns}
                data={this.props.data}
                totalPages={this.props.totalPages}
                totalCount={this.props.data.length}
                isTableLoading={this.props.isLoading}
                btnTxt="לפרטים"
                btnWidth="140px !important"
                isExpande
                expandedIdx={5}
                isHideTableTop={false}
                isHideExport={false}
                expandedRowRender={(record) => (
                  <DataList dataList={this.getDataList(record)} />
                )}
                expandButtonText="פרטים"
                onPagination={(page) => {
                  this.setState({ pageNo: page });
                }}
                onExportExcel={() => { this.props.onExportExcel(parseInt(this.state.selectedYear)) }}
                isLoadingExcel={this.props.isLoadingExcel}
                currentPage={this.state.pageNo}
              />
            </>
          )
        )}
      </div>
    );
  }
}
